











































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import DoctorSelector from "@/components/inputs/DoctorSelector.vue";
import PatientSelector from "@/components/inputs/PatientSelector.vue";
import { PatientModel } from "@/models/patient";
import { EventModel, EventType, EventStatus } from "@/models/event";
import EventDetail from "@/components/EventDetail/index.vue";
import EventsTableCard from "@/components/EventsTableCard.vue";
import { EventTypeIcon, EventTypeSelectionCard } from "@/components/EventType";
import { auth as authStore, auth, patient as store } from "@/store/modules";
import { format, parse } from "date-fns";
import { inject } from "inversify-props";
import { EventStatTableCard } from "@/components/EventStatTableCard.vue";
import { IEventService, IPatientService, EventFilter, IStatService, EventStatFilter } from "@/interfaces/Services";
import MassActionPerformModal, { MassActionItem } from '@/components/MassActionPerformModal.vue';
import { DateInput } from '@/components/inputs';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

@Component({
  components: {
    DoctorSelector,
    DateInput,
    EventStatTableCard
  }
})
export class EventStat extends Vue {
  @inject(DependencyIdentifiers.StatService)
  private statService!: IStatService;

  private isLoading = false;
  private componentKey = 0;
  private tableOptions: any = {};
  private filter: EventStatFilter = {
    doctorIds: [],
    from: '',
    until: '',
  };
  
  async mounted() {
    this.loadUrlParameters();
  }

  loadUrlParameters() {
    const query = this.$route.query;

    this.filter.from = query.dateFrom ? query.dateFrom.toString() : null;
    this.filter.until = query.until ? query.until.toString() : null;
    this.filter.doctorIds = query.doctorIds ? query.doctorIds.toString().split(',').filter(e => !!e) : null;
    this.tableOptions.page = query.page ? parseInt(query.page.toString()) : 1;
    this.tableOptions.itemsPerPage = query.itemsPerPage
      ? parseInt(query.itemsPerPage.toString())
      : this.tableOptions.itemsPerPage;
    this.componentKey++;
  }

  saveUrlParameters() {
    const query = {
      from: this.filter.from ? this.filter.from.toString() : '',
      until: this.filter.until ? this.filter.until.toString() : '',
      doctorIds: this.filter.doctorIds ? this.filter.doctorIds.join(',') : '',
      page: this.tableOptions.page,
      itemsPerPage: this.tableOptions.itemsPerPage
    };

    this.$router.push({path: '/dashboard/events/stat', query: query as any });
  }

  async onFilterDoctorChange(doctorId: string | null) {
    this.filter.doctorIds = doctorId ? [doctorId] : [];
  }

  @Watch("filter", {deep: true})
  onFilterUpdate() {
    this.saveUrlParameters();
  }

  onFilterFromChanged(date: string) {
    this.filter.from = date;
  }

  onFilterUntilChanged(date: string) {
    this.filter.until = date;
  }

  onTableOptionsChanged(options: any) {
    this.tableOptions = options;
    this.saveUrlParameters();
  }
}

export default EventStat;
